export const Minimize = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.1211 17.2364L17.0308 12.3267M17.0308 12.3267L12.1211 7.417M17.0308 12.3267L3.28366 12.3267" stroke="#1F1F1F" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"/>
        <path d="M21 4.26758L21 19.7315" stroke="#1F1F1F" strokeWidth="2" strokeLinecap="square"/>
        </svg>
    );
  };